import { toReversed } from "../../modules/common/utils/array.utils";
export class Shipment {
  constructor(attributes) {
    const attrs = { ...attributes };

    Object.keys(attrs).forEach((key) => {
      this[key] = attrs[key];
    });
  }

  //? methods related with the visits.
  get lastCompletedVisit() {
    return toReversed(this.visits).find((visit) => {
      return ["delivered", "not_delivered"].includes(visit.status);
    });
  }

  get lastVisit() {
    if (this.visits && this.visits.length > 0) {
      const lastIndex = this.visits.length - 1;
      return this.visits[lastIndex];
    }

    return null;
  }

  get isLastCompletedVisitNotDelivered() {
    const visit = this.lastCompletedVisit;

    if (visit) {
      return visit.status === "not_delivered";
    }

    return false;
  }

  get isLastVisitNotDelivered() {
    const lastVisit = this.lastVisit;

    if (lastVisit) {
      return lastVisit.status === "not_delivered";
    }

    return false;
  }
}
